module.exports = __webpack_public_path__ + "img/58.26406ee1.jpg";